export default __webpack_public_path__ + "static/media/serviceImg2.a0a0e772.svg";